import { render } from "./AddDependent.vue?vue&type=template&id=68845d3e&ts=true"
import script from "./AddDependent.vue?vue&type=script&lang=ts"
export * from "./AddDependent.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__